import { Component, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DayReportStateService } from '../day-report-state.service';

export type DayReportPage = 'formulier' | 'productie' | 'urenregistratie';

@Component({
    selector: 'app-day-report-buttons',
    standalone: false,
    templateUrl: './day-report-buttons.component.html',
    styleUrl: './day-report-buttons.component.scss',
})
export class DayReportButtonsComponent {
    private stateService = inject(DayReportStateService);

    readonly activePage = input.required<DayReportPage>();
    readonly actionButtonText = input<string | null>(null);
    readonly actionButtonIcon = input<string | null>(null);
    readonly navigationDisabled = input(false);
    readonly showActionButton = input(false);
    readonly actionButtonDisabled = input(false);

    readonly actionButtonClick = output<void>();

    readonly planning = toSignal(this.stateService.planning$);

    onActionButtonClick(): void {
        this.actionButtonClick.emit();
    }
}
